(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g_password-footer"]) return;
  try {
    
    const pwdFooter = document.querySelector('[data-password-footer]');
    document.documentElement.style.setProperty('--password-footer-height', `${pwdFooter.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-header"]) return;
  try {
    
    const pwdHeader = document.querySelector('[data-password-header]');
    document.documentElement.style.setProperty('--password-header-height', `${pwdHeader.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-showbuilder"] && !window.DesignMode) return;
  try {
    

/*********************************/
/********* GET SHOWS *********/
/*********************************/

// The first step is to initialize the glow library with your retailer ID.
glow.initialize({ retailerId: '179', themeColor: '#00add8' });

/*********************************/
/********* DISPLAY SHOWS *********/
/*********************************/


glow.createShowBuilder({
  container: '.show-display',
  // Replace `catalogUrl` value with your own URL pointing to a page of items eligible for the show builder.
  catalogUrl: 'https://rocketfireworks-ca.myshopify.com/pages/3d'
});

  } catch(e) { console.error(e); }
})();
})();
